<template>
  <form action="" class="form-register" @submit.prevent="">
    <TextField v-bind:data="textField" class="form-register__input form-register__input_text"/>
    <EmailField v-bind:data="emailField" class="form-register__input form-register__input_password"/>

    <SubmitButton class="form-register__button">
      Send Reques
    </SubmitButton>
  </form>
</template>

<script>
import TextField from '@/components/form-field/TextField'
import EmailField from '@/components/form-field/EmailField'
import SubmitButton from '@/components/button/Submit'

export default {
  name: 'Register',
  components: {
    TextField,
    EmailField,
    SubmitButton
  },
  data () {
    return {
      emailField: {
        id: 'email',
        name: 'email',
        placeholder: 'Enter email',
        label: 'Email',
        required: true,
        validationRule: 'required|email'
      },
      textField: {
        id: 'name',
        name: 'name',
        placeholder: 'Enter name',
        label: 'Name',
        required: true,
        validationRule: 'required|min:6'
      }
    }
  }
}
</script>

<style lang="scss">
  .form-register {
    &__input {
      margin-left: -41px;

      &_text {
        margin-bottom: 31px;
      }
    }

    &__button {
      display: block;
      width: 115px;
      margin-top: 30px;
      margin-left: auto;
      margin-right: 41px;
      background-color: #36a3f7;
      border-color: #36a3f7;
      color: #ffffff;
      letter-spacing: -0.4px;

      &:active {
        background-color: #318af0;
        border-color: #318af0;
      }
    }
  }
</style>
